import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import * as url from '_routes/url-names'
import { RecruitmentState } from '_root/constants';

import { PrimaryButton } from '_layout/buttons';
import { ResultList, ResultItem } from '_modules/search/common-layout/result-lists'

const ResultListWrapper = styled.div`
    overflow: auto;
    flex: 1;

    & .resultlist__fetchmore {
        display: block;
        margin: 20px auto;
    }
`

const DetailedRecruitmentsResults = props => {
    const { results, meta, onFetchMoreResults, isFetchingMore } = props;
    const metaCount = (meta && meta._count && meta._count._all) || 0

    const stateUrl = state => {
        switch (state) {
            case RecruitmentState.ACTIVE:
                return url.REK_AKTIVA
            case RecruitmentState.DRAFT:
                return url.REK_UTKAST
            case RecruitmentState.CLOSED:
                return url.REK_AVSLUTADE
            default:
                return ''
        }
    }

    return (
        <ResultListWrapper>
            <ResultList>
            {
                results.map((result) => 
                    <ResultItem key={result.id}>
                        <Link to={{ pathname: `/${result.company.urlName}/rekrytering${stateUrl(result.state)}/${result.id}${url.REK_APPLICATIONS}` }} target='_blank' rel='opener'>
                            { `${result.title} - (${result.company.name})` }
                        </Link>
                    </ResultItem>
                )
            }
            </ResultList>
            { (metaCount > results.length) && <PrimaryButton loading={isFetchingMore} className="resultlist__fetchmore" onClick={onFetchMoreResults}>Visa fler</PrimaryButton> }
        </ResultListWrapper>
    )
}

export default DetailedRecruitmentsResults